import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
  onClick: () => void;
}

export const DialogCloseButton: React.FC<Props> = ({ onClick }) => {
  return (
    <Tooltip title="Bezárás">
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          position: 'absolute',
          right: 12,
          top: 12,
          zIndex: 2,
          bgcolor: 'rgba(0,0,0,0.04)',
          '&:hover': {
            bgcolor: 'rgba(0,0,0,0.08)',
          },
        }}
      >
        <CloseRoundedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};